import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
const { inventoryTransformer: PixallInventoryTransformer } = PixallTransformers;

export function inventoryHistoryReportImpressions(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
        history,
    } = metadata;
    const { inventoryId, cmp } = data;
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const inventory = getInventoryOwnerById(state, inventoryId);
    const eventSource = 'vehicle-history-report';
    const payload = {
        clickType: inventory?.clickType,
        eventSource,
        eventType: 'impression',
        label: `${eventSource}::${cmp}`,
        pageId,
        ...PixallInventoryTransformer.getInventoryData(inventory),
        vehicleType: (inventory?.listingType || '').toLowerCase(),
        vendor: cmp,
    };

    Google.sendImpressions(metadata, {
        eventElement: 'partner',
        eventResult: `${eventSource}::${cmp}`,
        eventData: {
            vehicle: googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
        },
    }, option);

    Pixall.sendImpression({ dataLayer, history }, payload, option);
    return {};
}
